var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center mt-5 text-muted"},[_c('i',[_vm._v("please wait for redirection...")]),_c('br')])}]

export { render, staticRenderFns }